import { RegularExpression, RegularExpressionInvalidMessage, CountryCode } from '../enums';
/** This function retun regex and validation message based on country code*/
export const getZipRegexAndMessageByCountryCode = (countryCode) => {
    let zipValidation = {
        setZipValidationMessage: RegularExpressionInvalidMessage.ZIP_INVALID_US,
        setZipRegex: RegularExpression.ZIP_US
    };
    switch (countryCode) {
        case CountryCode.CANADA:
            zipValidation.setZipRegex = RegularExpression.ZIP_CA;
            zipValidation.setZipValidationMessage = RegularExpressionInvalidMessage.ZIP_INVALID_CA;
            break;
        case CountryCode.SPAIN:
            zipValidation.setZipRegex = RegularExpression.ZIP_ES;
            zipValidation.setZipValidationMessage = RegularExpressionInvalidMessage.ZIP_INVALID_ES;
            break;
        case CountryCode.FRANCE:
            zipValidation.setZipRegex = RegularExpression.ZIP_FR;
            zipValidation.setZipValidationMessage = RegularExpressionInvalidMessage.ZIP_INVALID_FR;
            break;
        case CountryCode.PUERTO_RICO:
            zipValidation.setZipRegex = RegularExpression.ZIP_PR;
            zipValidation.setZipValidationMessage = RegularExpressionInvalidMessage.ZIP_INVALID_PR;
            break;
        case CountryCode.ITALY:
            zipValidation.setZipRegex = RegularExpression.ZIP_IT;
            zipValidation.setZipValidationMessage = RegularExpressionInvalidMessage.ZIP_INVALID_IT;
            break;
        case CountryCode.GERMANY:
            zipValidation.setZipRegex = RegularExpression.ZIP_DE;
            zipValidation.setZipValidationMessage = RegularExpressionInvalidMessage.ZIP_INVALID_DE;
            break;
        case CountryCode.UNITED_KINGDOM:
            zipValidation.setZipRegex = RegularExpression.ZIP_GB;
            zipValidation.setZipValidationMessage = RegularExpressionInvalidMessage.ZIP_INVALID_GB;
            break;
    }
    return zipValidation;
};
//# sourceMappingURL=RegexUtils.js.map